import { Customization } from './Customization';
import { CustomizationObject } from './CustomizationObject';

export class CustomizationConfiguration {

  static getVersion(customizationConfiguration : CustomizationConfiguration) {
    return customizationConfiguration.version;
  }
  static getArrCustomizations(customizationConfiguration : CustomizationConfiguration) {
    return customizationConfiguration.customizations;
  }
  static getArrObjects(customizationConfiguration : CustomizationConfiguration) {
    return customizationConfiguration.objects;
  }

  public version : number = 0;
  public customizations : Array<Customization> = [];
  public objects : CustomizationObject[] = [];
}
